import {
  type CookieConsentTranslations,
  type EmbedsHomeTranslations,
  type FilterSheetTranslations,
  type MapTemplateTranslations,
  type NewsletterModalTranslations,
  type PlaceDetailTranslations,
  type SavedTemplateTranslations,
  SOCIAL_PLATFORM_LABEL,
  type TopBarTranslations,
} from '@fontbold/ui';

export const TOP_BAR_TRANSLATIONS: TopBarTranslations = {
  searchPlaceholder: 'Restaurant, keuken of stad',
};

export const NEWSLETTER_BUTTON_LABEL = 'Nieuwsbrief';

export const NEWSLETTER_MODAL_TRANSLATIONS: NewsletterModalTranslations = {
  eyebrow: 'NIEUWSBRIEF',
  heading: 'Elke vrijdag een plek die je moet kennen',
  subtext:
    'Nana stuurt je wekelijks een adres met het verhaal erachter. Geen hype, geen lijstjes van dertig.',
  placeholder: 'jouw@email.nl',
  submitLabel: 'Aanmelden',
  successHeading: 'Je staat op de lijst',
  successSubtext: 'Check je inbox, de eerste tip komt vrijdag.',
  errorMessage: 'Vul een geldig mailadres in.',
  closeLabel: 'Sluiten',
};

export const EMBEDS_HOME_TRANSLATIONS: EmbedsHomeTranslations = {
  headline: 'Culturen, verhalen en smaken komen samen.',
  intro: 'Nana ontdekt lokale, authentieke eetplekken over de hele wereld.',
  introEmphasis: 'F*ck de hype, ga voor authenticiteit.',
  aboutLinkLabel: 'Over het platform ->',
  placesLabel: 'plekken',
  citiesLabel: 'steden',
  citiesEyebrow: 'ONTDEK PER STAD',
  recentEyebrow: 'RECENT BEKEKEN',
  featureEyebrow: 'NIEUWSTE REEL',
  embedsTitle: 'Laatste reels',
  embedsMeta: 'plekken in kaart',
  mapLinkLabel: 'Bekijk op de kaart',
  emptyEmbedLabel: 'Geen foto',
};

export const MAP_TRANSLATIONS: MapTemplateTranslations = {
  title: 'Filters',
  clear: 'Wissen',
  listTitle: 'Dichtbij',
  resultCount: 'restaurants',
  openLabel: 'Nu open',
  emptyLabel: 'Geen foto',
  searchPlaceholder: 'Zoek restaurant of stad',
  clearAll: 'Alles wissen',
  nearbyTitle: 'Dichtbij',
  locateLabel: 'Mijn locatie',
};

export const FILTER_SHEET_TRANSLATIONS: FilterSheetTranslations = {
  searchPlaceholder: 'Restaurant, keuken of stad',
  nearbyLabel: 'In de buurt',
  showResults: (count: number) => `Toon ${count} plekken`,
  clear: 'Wissen',
  done: 'Gereed',
  allCuisines: 'Alle keukens',
};

export const PLACE_DETAIL_TRANSLATIONS: PlaceDetailTranslations = {
  embedBadge: 'REVIEW REEL',
  embedLink: (platform) => SOCIAL_PLATFORM_LABEL[platform],
  embedMeta: (handle: string, views: string) =>
    [handle ? `@${handle}` : '', views ? `${views} views` : '']
      .filter(Boolean)
      .join(' - '),
  embedAge: (ago: string) => `Reel van ${ago} geleden`,
  openLabel: 'Nu open',
  routeLabel: 'Route uitzetten',
  saveLabel: 'Opslaan',
  savedLabel: 'Opgeslagen',
  shareLabel: 'Delen',
  editLabel: 'Bewerken',
  closeLabel: 'Sluiten',
  tagsTitle: 'Tags',
  embedsTitle: 'Ook te zien op',
  embedsSubtitle: 'Nana kwam hier langs',
  reportPrompt: 'Gesloten of klopt de info niet?',
  reportAction: 'Meld het',
  emptyEmbedLabel: 'Geen foto',
};

export const COOKIE_CONSENT_TRANSLATIONS: CookieConsentTranslations = {
  heading: 'Cookies, oke?',
  body: 'We gebruiken een paar cookies om dingen te onthouden, zoals je bewaarde plekken. Jij mag kiezen wat je goed vindt.',
  acceptAllLabel: 'Alles goed',
  rejectAllLabel: 'Nee, liever niet',
  preferencesLabel: 'Kiezen',
  saveLabel: 'Voorkeuren opslaan',
  categories: {
    functional: {
      label: 'Onthouden',
      description:
        'Deze cookies onthouden jouw keuzes, zoals bewaarde plekken. Zonder deze cookies vergeten we dat elke keer opnieuw.',
    },
    analytics: {
      label: 'Foutjes opsporen',
      description:
        'Deze cookies helpen ons zien wanneer iets stuk is of traag gaat, zodat we het kunnen repareren.',
    },
  },
};

export const SAVED_TRANSLATIONS: SavedTemplateTranslations = {
  title: 'Bewaard',
  countLabel: (count: number) => `${count} ${count === 1 ? 'plek' : 'plekken'}`,
  emptyTitle: 'Nog niets bewaard',
  emptyBody: 'Klik op het hartje bij een plek om hem hier terug te vinden.',
  emptyCtaLabel: 'Bekijk de reels',
  emptyEmbedLabel: 'Geen foto',
};
